export const formatCurrency = (value, currency = "INR") => {
  const numeric = Number(value) || 0;
  const hasDecimals = !Number.isInteger(numeric);
  const locale = currency === "INR" ? "en-IN" : "en-US";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(numeric);
};
